module.exports = __webpack_public_path__ + "static/artist-marketing-the-results-mobile-8306f079eef2746f2577e790012e0dd0.webp";